import React from 'react';
import {
  Box,
} from '@material-ui/core';
import * as Yup from 'yup';

import {
  Step, TriggerType,
} from 'src/types';

import FormikInput from 'src/components/formik/FormikInput';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import useGetRequest from 'src/hooks/useGetRequest';
import SearchableList from 'src/components/SearchableList';
import { createStepWithTrigger } from 'src/utils/api';
import MiniCard from 'src/components/MiniCard';
import useModal from 'src/components/Modal/useModal';
import TriggerTypeMiniCard from 'src/components/miniCards/TriggerTypeMiniCard';
import TriggerBuilder from '../TriggerBuilder';
import { EVENT_ATTRIBUTES_BY_EVENT_TYPE, FORM_SUBMITTED, TRIGGER_TYPES } from '../../../../constants/constants';

interface Props {
  workflowId: string,
  refreshWorkflow: () => void,
  selectedElement: any,
  selectedElementOutgoers: any[],
}

const VALID_TRIGGERS = [
  FORM_SUBMITTED,
];

const ManageTrigger = ({
  workflowId,
  selectedElement,
  selectedElementOutgoers,
  refreshWorkflow,
}: Props) => {
  const [search, setSearch] = React.useState('');
  const [step, setStep] = React.useState<Step>();

  const fieldsConfig = [
    {
      name: 'triggerId',
    },
    {
      component: (_: any, formik: any) => (
        <SearchableList
          label="Trigger"
          options={TRIGGER_TYPES.filter((triggerType) => VALID_TRIGGERS.includes(triggerType)).map((triggerType) => EVENT_ATTRIBUTES_BY_EVENT_TYPE[triggerType])}
          searchKey="stepTitle"
          search={search}
          setSearch={setSearch}
          onOptionSelected={(attributes: any) => {
            createStepWithTrigger(workflowId, {
              id: selectedElement.id,
              toStepIds: selectedElementOutgoers.map((node) => node.id),
              workflowId,
              triggerType: attributes.eventType,
            }).then((_step: Step) => {
              setStep(_step);
              refreshWorkflow();
              formik.setFieldValue('triggerId', _step.triggerId);
              formik.setFieldValue('trigger', _step.trigger);
              formik.setFieldValue('name', _step.name);
            });
          }}
          renderOption={(option: any, onOptionSelected: () => void) => (
            <MiniCard
              icon={option.icon}
              label={option.stepTitle}
              description={option.stepDescription}
              onClick={() => onOptionSelected()}
            />
          )}
        />
      ),
      shouldRender: (formik: any) => !formik.values.triggerId,
    },
    {
      name: 'name',
      component: () => (
        <FormikInput
          fullWidth
          label="Step name"
          name="name"
          required
        />
      ),
      validator: Yup.string().required('This field is required.'),
      shouldRender: (formik: any) => Boolean(formik.values.triggerId),
    },
  ];

  return (
    selectedElement ? (
      <>
        <Box mt={2}>
          <CRUDConfigForm
            url={`/automatic/workflows/${workflowId}/steps/`}
            objectId={selectedElement.id}
            onFetchSuccess={(_step: Step) => {
              setStep(_step);
            }}
            onFetchError={() => {
              setStep(undefined);
            }}
            fieldsConfig={fieldsConfig}
            onSuccess={() => refreshWorkflow()}
            autoSave
          />
        </Box>
        <Box mt={2}>
          {
            // @ts-ignore
            Boolean(step) && <TriggerBuilder step={step} />
          }
        </Box>
      </>
    ) : null
  );
};

export default ManageTrigger;
